'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdHighQuality = function MdHighQuality(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.1 22.5v-5h3.4v5h-3.4z m5.9 0.9v-6.8c0-0.9-0.7-1.6-1.6-1.6h-5c-1 0-1.8 0.7-1.8 1.6v6.8c0 0.9 0.8 1.6 1.8 1.6h1.2v2.5h2.5v-2.5h1.3c0.9 0 1.6-0.7 1.6-1.6z m-11.6 1.6v-10h-2.5v4.1h-3.4v-4.1h-2.5v10h2.5v-3.4h3.4v3.4h2.5z m13.2-18.4c1.8 0 3.4 1.6 3.4 3.4v20c0 1.8-1.6 3.4-3.4 3.4h-23.2c-1.9 0-3.4-1.6-3.4-3.4v-20c0-1.8 1.5-3.4 3.4-3.4h23.2z' })
        )
    );
};

exports.default = MdHighQuality;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/high-quality.js
// module id = 2966
// module chunks = 0